module.exports = __webpack_public_path__ + "img/icon_confirm_redeem.svg";